// export const webDomain = 'https://twinbusipweb.se.com';
// export const ciamDomain = 'https://pprodbfo22-secommunities.cs209.force.com';
// export const ciamAppName = 'twinbusip';
// export const ciamRedirectUri = 'https%3A%2F%2Ftwinbusipweb.se.com%2Fhome%2Fdevice';

// test env
// export const ciamRedirectUriForLogout = 'https://twinbusportal.westeurope.cloudapp.azure.com/logout';

// product env
export const ciamRedirectUriForLogout = 'https://twinbusipweb.se.com/logout';

export const webDomain = document.domain;

// export const ciamDomain = 'https://idp-int.se.com'; // test env
// export const ciamDomain = 'https://idp-uat.se.com'; // edit by sam 20240618 for uat env config

// product env
export const ciamDomain = 'https://idp.se.com';

export const ciamAppName = 'twinbusip';

// export const ciamClientId = 'Gs5WQXoh7sRqpfd4T5BWjVssvTnZaYRm'; // test env
export const ciamClientId = '4TIvPP547FgtdA8z7OJO1SwfgQPu9ER7'; // product env


// edit by sam 20240618 for uat env config
// export const ciamRedirectUri = 'https://twinbusportal.westeurope.cloudapp.azure.com/home/device';
// product env
export const ciamRedirectUri = 'https://twinbusipweb.se.com/home/device';

// Test Env
// export const ciamRedirectUriForLogout = 'https://twinbusportal.westeurope.cloudapp.azure.com';

// export const webDomain = document.domain;
// export const ciamDomain = 'https://sitbfo19-secommunities.cs17.force.com';
// export const ciamAppName = 'twinbusip';
// export const ciamClientId =
// '3MVG9ahGHqp.k2_xWoKZZKzfq3rtHPm8BmmS2QiXqYR6hHlhRdxlEVOj8Xg5cnOwv40.VbQG.wINySi9_2dWL';
// export const ciamRedirectUri = 'https%3A%2F%2Ftwinbusportal.westeurope.cloudapp.azure.com';


// Local Development Env
// export const ciamRedirectUriForLogout = 'https://tbs.gaoby.cn';

// export const webDomain = document.domain;
// export const ciamDomain = 'https://pprodbfo22-secommunities.cs209.force.com';
// export const ciamAppName = 'twinbusip';
// export const ciamClientId =
// '3MVG9qhihEtB2ojiOpZPqT82aYuxWYODgH4jcQMNZnvI_DS6fgdMgq33_WDyplKOWFs71QKNeujU.KOg9MQvk';
// export const ciamRedirectUri = 'https%3A%2F%2Ftbs.gaoby.cn%2Fhome%2Fdevice';
